<template>
  <div class="holiday-rule-root" :class="{ 'no-sort': !(prize1 && prize1.rank) }">
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px`">
      <van-nav-bar class="van-bar" :title="$t('lang.commonM.k111')" left-arrow @click-left="goPrevious">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow02.png" alt="" />
        </template>
      </van-nav-bar>
    </div>

    <img class="bg-img" src="./images/rules-bg.png" :style="{ 'margin-top': `-${barHeight + 46}px` }" />
    <div class="bg-block">
      <div class="item-block">
        <div class="item-tit">{{ $t('lang.commonM.k230') }}</div>
        <div class="item-txt" v-if="mexActStartTime && mexActEndTime">
          {{ $t('lang.commonM.k231') }}:
          <br />
          <i style="color: #ff9524">{{ mexActStartTime }} - {{ mexActEndTime }}</i>
        </div>
        <div class="item-txt">{{ $t('lang.commonM.k250') }}</div>
      </div>

      <div class="item-block">
        <div class="item-tit">{{ $t('lang.commonM.k233') }}</div>
        <div class="item-txt">{{ $t('lang.commonM.k234') }}</div>
        <div class="gift-num" style="margin-top: 16px">
          <div>
            <img src="@/assets/packageAssets/common/Pumpkin.png" alt="" />
            {{ $t('lang.commonM.k334') }}
          </div>
          <span>
            <i>1</i>
            {{ $t('lang.valRuFe.points') }}
          </span>
        </div>
        <div class="gift-num" style="margin-top: 16px">
          <div>
            <img src="@/assets/packageAssets/common/Ring.png" alt="" />
            {{ $t('lang.commonM.k211') }}
          </div>
          <span>
            <i>3</i>
            {{ $t('lang.valRuFe.points') }}
          </span>
        </div>
        <div class="gift-num" style="margin-top: 16px">
          <div>
            <img src="@/assets/packageAssets/common/CandyBag.png" alt="" />
            {{ $t('lang.commonM.k335') }}
          </div>
          <span>
            <i>5</i>
            {{ $t('lang.valRuFe.points') }}
          </span>
        </div>
        <div class="gift-num" style="margin-top: 16px">
          <div>
            <img src="@/assets/packageAssets/common/Kiss.png" alt="" />
            {{ $t('lang.commonM.k305') }}
          </div>
          <span>
            <i>15</i>
            {{ $t('lang.valRuFe.points') }}
          </span>
        </div>
        <div class="gift-num" style="margin-top: 16px">
          <div>
            <img src="@/assets/packageAssets/common/Treasure.png" alt="" />
            {{ $t('lang.commonM.k306') }}
          </div>
          <span>
            <i>50</i>
            {{ $t('lang.valRuFe.points') }}
          </span>
        </div>
      </div>

      <div class="item-block">
        <div class="item-tit">{{ $t('lang.commonM.k215') }}</div>
        <div class="item-txt">{{ $t('lang.commonM.k235') }}</div>
        <div class="national-item" style="margin-top: 16px">
          <div class="reward-num">10 {{ $t('lang.valRuFe.points') }}</div>
          <div class="reward-coins">
            {{ milestoneData.num1Reward }}
            <img class="coins-icon" :src="getMatchImg('beans')" />
          </div>
        </div>
        <div class="national-item">
          <div class="reward-num">15 {{ $t('lang.valRuFe.points') }}</div>
          <div class="reward-coins">
            {{ milestoneData.num2Reward }}
            <img class="coins-icon" :src="getMatchImg('beans')" />
          </div>
        </div>
        <div class="national-item">
          <div class="reward-num">20 {{ $t('lang.valRuFe.points') }}</div>
          <div class="reward-coins">
            {{ milestoneData.num3Reward }}
            <img class="coins-icon" :src="getMatchImg('beans')" />
          </div>
        </div>
      </div>

      <div class="item-block">
        <div class="item-tit">{{ $t('lang.commonM.k238') }}</div>
        <div class="item-txt">{{ $t('lang.commonM.k239') }}</div>

        <div class="national-item" style="margin-top: 16px">
          <div class="reward-num">No.1</div>
          <div class="reward-coins">
            {{ boardData.num1Reward }}
            <img class="coins-icon" :src="getMatchImg('beans')" />
          </div>
        </div>
        <div class="national-item">
          <div class="reward-num">No.2</div>
          <div class="reward-coins">
            {{ boardData.num2Reward }}
            <img class="coins-icon" :src="getMatchImg('beans')" />
          </div>
        </div>
        <div class="national-item">
          <div class="reward-num">No.3</div>
          <div class="reward-coins">
            {{ boardData.num3Reward }}
            <img class="coins-icon" :src="getMatchImg('beans')" />
          </div>
        </div>
        <div class="national-item">
          <div class="reward-num">No.4-10</div>
          <div class="reward-coins">
            {{ boardData.num4Reward }}
            <img class="coins-icon" :src="getMatchImg('beans')" />
          </div>
        </div>
      </div>

      <div class="item-block">
        <div class="item-tit">{{ $t('lang.commonM.k236') }}</div>
        <div class="item-txt">{{ $t('lang.commonM.k106') }}</div>
      </div>

      <div class="item-block">
        <div class="item-tit">{{ $t('lang.commonM.k237') }}</div>
        <div class="item-txt">{{ $t('lang.commonM.k107') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { holidayActBaseInfo } from './apidir/api.js'

export default {
  data() {
    return {
      mexActStartTime: '',
      mexActEndTime: '',
      milestoneData: {
        num1Reward: 0,
        num2Reward: 0,
        num3Reward: 0
      },
      boardData: {
        num1Reward: 0,
        num2Reward: 0,
        num3Reward: 0,
        num4Reward: 0
      }
    }
  },
  methods: {
    // 获取数据
    fetchData() {
      holidayActBaseInfo().then((resData) => {
        if (!resData) return
        if (resData.startTimestamp) {
          this.mexActStartTime = this.handleMoment(resData.startTimestamp, 'YYYY-MM-DD HH:mm:ss')
        }
        if (resData.endTimestamp) {
          this.mexActEndTime = this.handleMoment(resData.endTimestamp, 'YYYY-MM-DD HH:mm:ss')
        }

        if (resData.milestoneRewards && resData.milestoneRewards.length) {
          this.milestoneData.num1Reward = resData.milestoneRewards[0] || 0
          this.milestoneData.num2Reward = resData.milestoneRewards[1] || 0
          this.milestoneData.num3Reward = resData.milestoneRewards[2] || 0
        }

        if (resData.leaderboardRewards && resData.leaderboardRewards.length) {
          this.boardData.num1Reward = resData.leaderboardRewards[0] || 0
          this.boardData.num2Reward = resData.leaderboardRewards[1] || 0
          this.boardData.num3Reward = resData.leaderboardRewards[2] || 0
          this.boardData.num4Reward = resData.leaderboardRewards[3] || 0
        }
      })
    }
  },
  created() {
    this.fetchData()
  }
}
</script>

<style lang="less" scoped>
img:not([src]) {
  opacity: 0;
}

.holiday-rule-root {
  width: 100%;
  min-height: calc(100vh - 150px);
  background: #29093c;

  .custom-nav-block {
    background: url(./images/rules-bg.png) top left / 100% auto no-repeat;
  }

  .bg-img {
    width: 100%;
  }

  .bg-block {
    position: relative;
    margin-top: -50px;
    min-height: 100vh;

    padding: 20px 10px;

    .item-block {
      width: 100%;
      padding: 16px;
      margin-bottom: 16px;
      background: #442753;
      border-radius: 12px;

      .item-tit {
        line-height: 22px;
        font-family: TikTok Sans;
        font-weight: 600;
        font-size: 17px;
        color: #d7cae1;
        line-height: 22px;
      }

      .item-txt {
        width: 323px;
        line-height: 22px;
        font-family: TikTok Sans;
        font-weight: 400;
        font-size: 15px;
        color: #d7cae1;
        margin-top: 8px;
      }

      .gift-num {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 14px;
        > div {
          display: flex;
          align-items: center;
          gap: 10px;

          font-family: TikTok Sans;
          font-weight: 400;
          font-size: 17px;
          color: #d7cae1;
          line-height: 20px;

          img {
            width: 24px;
            height: 24px;
          }
        }
        > span {
          font-family: TikTok Sans;
          font-weight: 400;
          font-size: 17px;
          color: #d7cae1;
          line-height: 20px;
          text-align: right;
        }
      }

      .national-item {
        font-family: TikTok Sans;
        font-weight: 400;
        font-size: 15px;
        color: #d7cae1;
        line-height: 20px;
        display: flex;
        justify-content: space-between;
        margin-bottom: 12px;
        .reward-coins {
          display: flex;
          align-items: center;
          font-weight: bold;
          .coins-icon {
            width: 16px;
            height: 16px;
            margin-left: 4px;
          }
        }
      }
    }
  }
}

::v-deep .van-nav-bar__title {
  font-size: 17px;
  font-family: Inter;
  font-weight: 600;
  color: #ffffff;
}
::v-deep .van-nav-bar__right .tit-right {
  line-height: 16px !important;
}
</style>
